<template>
  <div id="credit-packets">
    <div class="content-wrapper">
      <portal to="action-buttons"></portal>
      <div class="content animated fadeIn">
        <div
          class="card"
          style="padding: 0px; box-shadow: unset; padding: 20px"
        >
          <div class="row">
            <div class="col-md-12">
              <div style="display: flex">
                <el-input
                  v-model="code"
                  type="text"
                  :placeholder="$t('enterCCode')"
                  style="border-radius: 0px"
                />
                <el-button @click="applyCouponCode">{{$t('activeIt')}}</el-button>
              </div>
            </div>
            <div class="col-md-12" style="margin-top: 20px">
              <div class="row" v-if="selectedPacket != null">
                <div class="col-md-6">
                  <h4>{{$t('selectedPack')}}</h4>
                  <div class="card col-md-12">
                    <div class="card-body text-center">
                      <h4 class="mt-2 mb-3">{{ getSelectedPacket.title }}</h4>
                      <h1 class="pricing-table-price">
                        {{ getSelectedPacket.credit }}
                        <span
                          class="ml-1"
                          style="font-size: 13px; font-style: italic"
                          >{{$t('credit')}}</span
                        >
                      </h1>
                      <p
                        v-html="getSelectedPacket.details"
                        style="min-height: 150px"
                      ></p>
                      <h3>
                        <strong>{{$t('packPrice')}}:</strong>
                        {{ $formatMoney(getSelectedPacket.price) }}
                        ₺
                      </h3>
                      <h3>
                        <strong>{{$t('event.table.kdv')}}:</strong>
                        {{ $formatMoney(0) }}
                        ₺
                      </h3>
                      <h3>
                        <strong>{{$t('totalUpper')}}:</strong>
                        {{
                          $formatMoney(
                            getSelectedPacket.price
                          )
                        }}
                        ₺
                      </h3>
                      <a
                        @click="selectedPacket = null"
                        href="javascript:;"
                        class="btn bg-indigo-400 btn-lg text-uppercase font-size-sm font-weight-semibold"
                        >{{$t('backToPackSel')}}</a
                      >
                    </div>
                    <div
                      class="ribbon-container"
                      v-if="getSelectedPacket.isPopular"
                    >
                      <div class="ribbon bg-indigo-400">{{$t('popular')}}</div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-6"
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <VCreditCard
                    :trans="cardConfig"
                    @change="creditInfoChanged"
                  />
                  <el-button
                    type="success"
                    style="width: 90%"
                    @click="startPayment"
                  >
                    {{
                      $formatMoney(
                        getSelectedPacket.price
                      )
                    }}₺ {{$t('pay')}}
                  </el-button>
                </div>
              </div>

              <div class="row" v-if="selectedPacket == null">
                <div
                  class="card col-md-3"
                  v-for="(item, index) in packets"
                  :key="item.id"
                >
                  <div class="card-body text-center">
                    <h4 class="mt-2 mb-3">{{ item.title }}</h4>
                    <h1 class="pricing-table-price">
                      {{ item.credit }}
                      <span
                        class="ml-1"
                        style="font-size: 13px; font-style: italic"
                        >{{$t('credit')}}</span
                      >
                    </h1>
                    <p v-html="item.details" style="min-height: 150px"></p>
                    <a
                      href="javascript:;"
                      @click="selectedPacket = item.id"
                      class="btn bg-indigo-400 btn-lg text-uppercase font-size-sm font-weight-semibold"
                    >
                      Satın Al
                      <strong>{{ $formatMoney(item.price) }}</strong> ₺
                    </a>
                  </div>
                  <div class="ribbon-container" v-if="item.isPopular">
                    <div class="ribbon bg-indigo-400">{{$t('popular')}}</div>
                  </div>
                </div>
              </div>

              <div
                class="card bg-info text-white"
                v-if="selectedPacket == null"
              >
                <div class="card-header header-elements-inline">
                  <h6 class="card-title font-weight-bold">
                    {{$t('doYouNeedCredit')}}
                  </h6>
                </div>

                <div class="card-body font-weight-bold">
                  <template v-if="$i18n.locale == 'tr'">
                    Holacon Enterprise;
                    <br />Daha büyük kredi ihtiyaçlarınız için size özel
                    oluşturduğumuz kredi planlamalarından faydalanmak için;
                    <br />Bizimle
                    <a
                      href="mailto:sales@holacon.com"
                      class="text-dark font-weight-bold"
                      >sales@holacon.com</a
                    >
                    adresi üzerinden iletişime geçebilirsiniz.
                  </template>
                  <template v-else>
                    Holacon Enterprise;
                    <br />
                    Specially for your larger loan needs;
                    <br />
                    You can contact us at
                    <a
                      href="mailto:sales@holacon.com"
                      class="text-dark font-weight-bold"
                      >sales@holacon.com</a
                    >
                    to take advantage of the loan plans we have created.
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <form style="display: none" :action="url" method="post" id="paymentForm">
      <input type="text" name="CardNumber" :value="request.cardNO" />
      <input type="text" name="CardLastYear" :value="request.year" />
      <input type="text" name="CardLastMonth" :value="request.month" />
      <input type="text" name="CardCVV" :value="request.cvv" />
      <button type="submit" id="goThreed">{{$t('event.buttons.go')}}</button>
    </form>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="modalVisible"
      :title="$t('event.tags.editSubEvent')"
      width="60%"
    >
      <SubEventAddUpdate
        @deleteMe="deleteItem"
        @closeMe="modalVisible = false"
        @itemUpdated="itemUpdated"
        @itemAdded="itemAdded"
        :data="updateForm"
      />
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import PageCountInfo from "./PageCountInfo";
import SubEventAddUpdate from "./SubEventAddUpdate";
import VCreditCard from "v-credit-card";
import $ from "jquery";
export default {
  components: { PageCountInfo, SubEventAddUpdate, VCreditCard },
  name: "SubEvents",
  data() {
    return {
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "questionlibrary",
      packets: [],
      code: null,
      selectedPacket: null,
      cardConfig: {
        name: {
          label: "Kart Üzerindeki İsim",
          placeholder: "İsim Soyisim",
        },
        card: {
          label: "Kart Numarası",
          placeholder: "1111 2222 3333 4444",
        },
        expiration: {
          label: "SKT",
        },
        security: {
          label: "CVC",
          placeholder: "111",
        },
      },
      card: {
        cardNumber: "",
        expiration: "",
        name: "",
        security: "",
      },
      request: {
        redirectURL: null,
        packetID: null,
        cardNO: null,
        holderName: null,
        cvv: null,
        year: null,
        month: null,
      },
      url: null,
    };
  },
  methods: {
    startPayment() {
      var req = {
        redirectURL: window.location.href,
        packetID: this.selectedPacket,
        cardNO: this.card.cardNumber.split(" ").join(""),
        holderName: this.card.name,
        cvv: parseInt(this.card.security),
        year: 2000 + parseInt(this.card.expiration.split("/")[1]),
        month: parseInt(this.card.expiration.split("/")[0]),
      };
      axios.post("payment/startpayment", req).then((res) => {
        if (res.data.alert.hasError) {
          this.$message.error(res.data.alert.message);
        } else {
          this.request = req;
          this.url = res.data.data.threedsURL;
          setTimeout(() => {
            $("#paymentForm").submit();
          }, 200);
        }
      });
    },
    creditInfoChanged(values) {
      this.card = values;
    },
    handleSizeChange(take) {
      this.$store.commit("setSubEventsTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setSubEventsPage", page);
    },
    itemUpdated(item) {
      var index = this.$store.state.subevents.items.findIndex(
        (k) => k.id == item.id
      );
      if (index != -1) {
        this.$store.state.subevents.items.splice(index, 1, item);
      }
    },
    itemAdded(item) {
      this.$store.dispatch("getSubEvents");
    },
    deleteItem(index) {
      this.$store.dispatch("deleteSubEvent", { index, context: this });
    },
    confirmItem(index) {
      this.$store.dispatch("confirmSubEvents", { index, context: this });
    },
    cancelItem(index) {
      this.$store.dispatch("cancelSubEvents", { index, context: this });
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleSubEvents", { index, value });
    },
    applyCouponCode() {
      axios.post("payment/applycouponcode", { code: this.code }).then((res) => {
        if (res.data.alert.hasError) {
          this.$message.error(res.data.alert.message);
        } else {
          this.$message.success(res.data.alert.message);
          this.$store.dispatch("getUser");
          this.code = null;
        }
      });
    },
  },
  mounted() {
    axios.post("payment/loadpackets").then((res) => {
      this.packets = res.data.data.items;
    });
    this.$store.dispatch("getUser");
  },
  created() {},
  computed: {
    getSelectedPacket() {
      return this.packets.find((k) => k.id == this.selectedPacket);
    },
    skip() {
      return (
        (this.$store.state.subevents.filter.page - 1) *
        this.$store.state.subevents.filter.take
      );
    },
    take() {
      return this.skip + this.$store.state.subevents.items.length;
    },
  },
  watch: {
    "$store.state.subevents.filter.searchTerm": function () {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getQuestionLibrary");
      }, 500);
    },
  },
};
</script>
<style>
.vue-credit-card .card-form-and-image .credit-card-form .field label {
  margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CreditPackets.vue